// import React, {useState, useEffect} from "react";
// import SettingsPopup from "../Popups/Popups";
// import OpenDisputeAttach from "../Assets/OpenDisputeAttach.svg"

// const SettingsOpenDispute = () => {
//     const Border = "border-[#E2E2E2] border-[1px] border-solid";

//     const [formData, setFormData] = useState({
//         EnrolledCourseDispute:"",
//         disputeSubject: "",
//         disputeReason: "",
//         lastClassReceived: "",
//         attachment: null,
//     });

//     const [previewImage, setPreviewImage] = useState(null);
//     const [showPopup, setShowPopup] = useState(false);

//     // Handle input, select, and textarea changes
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     // Handle file input
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setFormData({ ...formData, attachment: file });
//             setPreviewImage(URL.createObjectURL(file)); // Show preview
//         }
//     };

//     // Submit form
//     const handleSubmit = async () => {
//         console.log("formData in handleSubmit is:",formData)
//         const formPayload = new FormData();
//         formPayload.append("disputeSubject", formData.disputeSubject);
//         formPayload.append("disputeReason", formData.disputeReason);
//         formPayload.append("lastClassReceived", formData.lastClassReceived);
//         if (formData.attachment) {
//             formPayload.append("attachment", formData.attachment);
//         }

//         try {
//             const response = await fetch("/api/dispute", {
//                 method: "POST",
//                 body: formPayload,
//             });

//             if (response.ok) {
//                 setShowPopup(true);
//             } else {
//                 console.error("Failed to submit dispute");
//             }
//         } catch (error) {
//             console.error("Error submitting dispute:", error);
//         }
//     };

//     return (
//         <>
//             <div className="w-full flex flex-col gap-[10px]" >
//                 <p className="text-[#404040] text-[20px] font-bold">Open Dispute</p>
//                 <div className=" w-[90%] flex flex-col gap-[20px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[20px]">
//                     {/* DisputeSubject */}
//                     <div className="flex flex-col gap-[10px]">
//                         <label
//                             htmlFor="DisputeSubject"
//                             className="text-[#404040] text-[18px] font-bold"
//                         >
//                             What is this dispute about?*
//                         </label>
//                         <input
//                             type="text"
//                             id="EnrolledCourseDispute"
//                             name="EnrolledCourseDispute"
//                             placeholder="Select Enrolled Course."
//                             value={formData.EnrolledCourseDispute}
//                             onChange={handleChange}
//                             className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
//                         />
//                     </div>

//                     {/* DisputeSubject1 */}
//                     <div className="flex flex-col gap-[10px]">
//                         <label
//                             htmlFor="DisputeSubject"
//                             className="text-[#404040] text-[18px] "
//                         >
//                             1. What is this dispute about?*
//                         </label>
//                         <select
//                             id="disputeSubject"
//                             name="disputeSubject"
//                             className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029]`}
//                             value={formData.disputeSubject}
//                             onChange={handleChange}
//                         >
//                             <option value="Charged different amount then expected" >1. Charged different amount then expected.</option>
//                             <option value="Instruction method is not satisfactory">2. Instruction method is not satisfactory.</option>
//                             <option value="Class schedule conflicting with priorities">3. Class schedule conflicting with priorities.</option>
//                             <option value="Unable to continue training due to personal reasons.">4. Unable to continue training due to personal reasons.</option>
//                             <option value="Registered in a wrong course">5. Registered in a wrong course.</option>
//                             <option value="Distance from Training Institute is unmanageable">6. Distance from Training Institute is unmanageable.</option>
//                         </select>
//                     </div>

//                     <div className="flex flex-col gap-[10px]">
//                         <label
//                             htmlFor="DisputeSubject"
//                             className="text-[#404040] text-[18px]"
//                         >
//                             2. Did you received your last class on 18/03/2024 ?
//                         </label>
//                         <div className="flex gap-[10px]">
//                             <input
//                                 type="radio"
//                                 id="yes"
//                                 name="lastClassReceived"
//                                 value="yes"
//                                 checked={formData.lastClassReceived === "yes"}
//                                 onChange={handleChange}
//                                 className="mr-2"
//                             />
//                             <label htmlFor="yes" className="text-[18px] text-[#404040]">
//                                 Yes
//                             </label>
//                         </div>
//                         <div className="flex gap-[10px]">
//                             <input
//                                 type="radio"
//                                 id="no"
//                                 name="lastClassReceived"
//                                 value="no"
//                                 checked={formData.lastClassReceived === "no"}
//                                 onChange={handleChange}
//                                 className="mr-2"
//                             />
//                             <label htmlFor="no" className="text-[18px] text-[#404040]">
//                                 No
//                             </label>
//                         </div>
//                     </div>

//                     <div className="flex flex-col gap-[10px]">
//                         <label
//                             htmlFor="disputeReason"
//                             className="text-[#404040] text-[18px]"
//                         >
//                             3. Please provide your reason why did you applied for the dispute?
//                         </label>
//                         <textarea
//                              id="disputeReason"
//                             name="disputeReason"
//                             placeholder="Enter your reason here..."
//                             className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029]`}
//                             style={{ height: "150px" }}
//                             value={formData.disputeReason}
//                             onChange={handleChange}
//                         ></textarea>
//                     </div>

//                     {/* Attachments */}
//                     <div className="flex flex-col gap-[10px]">
//                         <label
//                             className="text-[#404040] text-[18px]"
//                         >
//                             4. Attach any document, image or proof.
//                         </label>
//                         <div className="flex gap-[5px]">
//                         {previewImage ? (
//                                 <img src={previewImage} alt="Preview" className="h-[80px] w-[90px] object-cover" />
//                             ) : (
//                         <label className="h-[80px] w-[90px] flex items-center justify-center bg-[#A1A3EF] text-white cursor-pointer">
//                             <input
//                                 type="file"
//                                 accept="image/*"
//                                 className="hidden"
//                                 // onChange={handleFileChange}
//                             />
//                                 Attach
//                             </label>
//                             )}
//                             <img src={OpenDisputeAttach} alt="Attach Icon" className="mt-[-10px]" onClick={handleFileChange}/>
//                              <p className="text-[#000000] text-[12px]">Jpeg, PNG, PDF or Giff</p>
//                         </div>
//                     </div>

//                 </div>

//                 {showPopup && (
//                     <SettingsPopup
//                         setShowPopup={setShowPopup}
//                         text="The Dispute has been created we will try to resolve The dispute as soon as possible."
//                     />
//                 )}

//                 <div className="w-[90%] flex justify-end mt-[10px]">
//                     <button
//                     className="w-[110px] h-[44px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px]"
//                     onClick={handleSubmit}
//                     >
//                         Submit
//                     </button>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default SettingsOpenDispute ;

import React, { useState, useRef, useEffect } from "react";
import SettingsPopup from "../Popups/Popups";
import OpenDisputeAttach from "../Assets/OpenDisputeAttach.svg";
import { UpdateSettingsOpenDisputeTable } from "../../../Actions/StudentA";
import { useDispatch, useSelector } from "react-redux";
import OpenDisputeHistory from "../OpenDisputeHistory/OpenDisputeHistory";
import { GetStudentTimeTableForTheEnrolledCourse } from "../../../Actions/CourseA";
import NoDataResponse from "../../../Components/NoDataResponse";

const SettingsOpenDispute = ({UserId, EnrolledCourses}) => {
    const Dispatch = useDispatch();
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const fileInputRef = useRef(null); // Ref for the file input
    const [lastClassDate, setLastClassDate] = useState(null);
    const [errors, setErrors] = useState();
    const [enrolledCourses, setEnrolledCourses] = useState([]);
    const [enrolledCoursesError, setEnrolledCoursesError] = useState([]);


    console.log("EnrolledCourses in SettingsOpenDispute are:",EnrolledCourses)
    const { enrolledCourseTimeTable } = useSelector((Store) => Store.CourseReducer);

    console.log("enrolledCourseTimeTable in SettingsOpenDispute are:",enrolledCourseTimeTable)

    const [formData, setFormData] = useState({
        EnrolledCourseDispute: "",
        disputeSubject: "",
        disputeReason: "",
        lastClassReceived: "",
        attachment: null,
    });

    const [previewImage, setPreviewImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    console.log("Enrolled Courses:", enrolledCourses);

    // Handle input, select, and textarea changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleEnrolledCourseChange = (e) => {
        setEnrolledCoursesError("");
         // Reset the EnrolledCourseDispute field in formData
        setFormData((prev) => ({
            ...prev,
            EnrolledCourseDispute: "",
        }));
        const selectedCourseName = e.target.value;

        // Check if a dispute already exists for this course using enrolledCourses state
        if (enrolledCourses.includes(selectedCourseName)) {
            setEnrolledCoursesError("You cannot create a dispute for this course as one already exists.");
            return;
        }
    
        // Find the selected course object based on CourseName
        const selectedCourse = EnrolledCourses.find(
            (course) => course.CoursePackage.InstituteCourse.Course.CourseName === selectedCourseName
        );
    
        if (selectedCourse) {
            const EnrollmentId = selectedCourse.EnrollmentId;
            console.log("EnrollmentId in the function is:",EnrollmentId)
    
            // Update formData with the selected course name
            setFormData((prev) => ({
                ...prev,
                EnrolledCourseDispute: selectedCourseName,
            }));
    
            // Dispatch the function with EnrollmentId
            Dispatch(GetStudentTimeTableForTheEnrolledCourse(EnrollmentId));
        }
    };

    // Handle file input change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, attachment: file });
            setPreviewImage(URL.createObjectURL(file)); // Generate preview
        }
    };

    // Trigger file input when clicking the attach icon
    const handleAttachIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    useEffect(() => {
        if (enrolledCourseTimeTable?.timetable?.length > 0) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Remove time part to compare dates only
    
            // Filter events where startDate is before today
            const pastEvents = enrolledCourseTimeTable.timetable
                .map(event => ({
                    ...event,
                    startDate: new Date(event.startDate),
                }))
                .filter(event => event.startDate < today);
    
            if (pastEvents.length > 0) {
                // Find the most recent past event (latest before today)
                const mostRecentEvent = pastEvents.reduce((prev, curr) => 
                    curr.startDate > prev.startDate ? curr : prev
                );
    
                // Format the date as DD/MM/YYYY
                const formattedDate = mostRecentEvent.startDate.toLocaleDateString("en-GB");
    
                setLastClassDate(formattedDate);
            } else {
                setLastClassDate(null); // No past classes, hide div
            }
        }
    }, [enrolledCourseTimeTable]);

    // Submit form
    const handleSubmit = async () => {
        console.log("formData in handleSubmit is:", formData);
        // Check if required fields are empty
        if (!formData.EnrolledCourseDispute || !formData.disputeSubject || !formData.disputeReason) {
            // alert("Please fill in all required fields."); // You can replace this with a better UI error message
            setErrors("Please fill in all required fields.")
            return;
        }

        // If lastClassDate exists, check lastClassReceived
        if (lastClassDate && !formData.lastClassReceived) {
            // alert("Please enter the last class received.");
            setErrors("Please enter the last class received.")
            return;
        }
        
        const data = new FormData();
        data.append("EnrolledCourseDispute", formData.EnrolledCourseDispute);
        data.append("disputeSubject", formData.disputeSubject);
        data.append("disputeReason", formData.disputeReason);
        data.append("lastClassReceived", formData.lastClassReceived);

        // Append file (if it exists)
        if (formData.attachment) {
            data.append("attachment", formData.attachment);
        }

        Dispatch(UpdateSettingsOpenDisputeTable(UserId,data))
        .then(() => {
          setShowPopup(true); // Show popup on successful update
           // Set a timeout to refresh the page after 5 seconds
           setTimeout(() => {
                window.location.reload();
           }, 5000);

        })
        .catch((error) => {
          console.error("Error updating settings:", error);
          // Handle error if needed
        });
    };

    return (
        <>
            {EnrolledCourses ? (
            <div className="w-full flex flex-col justify-center items-center gap-[20px]">
                <OpenDisputeHistory UserId={UserId} setEnrolledCourses={setEnrolledCourses} />
                <div className="w-[85%] flex flex-start">
                    <p className="hidden lg:block text-[#404040] text-[20px] font-bold">Open Dispute</p>
                </div>
                <div className="w-[100%] lg:w-[85%] flex flex-col gap-[20px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[20px]">
                    <p className="lg:hidden mb-[10px] text-[#404040] text-[20px] font-bold">Open Dispute</p>
                    {/* DisputeSubject */}
                    {enrolledCoursesError && (
                        <p className="text-[16px] text-[#ff0000]">{enrolledCoursesError}</p>
                    )}
                    <div className="flex flex-col gap-[10px]">
                        <label className="text-[#404040] text-[18px] font-bold">
                            What is this dispute about?*
                        </label>
                        <select
                            id="EnrolledCourseDispute"
                            name="EnrolledCourseDispute"
                            className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] text-[#000000]`}
                            value={formData.EnrolledCourseDispute}
                            onChange={handleEnrolledCourseChange}
                        >
                            <option value="">Select Enrolled Course</option>
                            {EnrolledCourses?.map((course, index) => (
                                <option key={index} value={course.CoursePackage.InstituteCourse.Course.CourseName}>
                                    {course.CoursePackage.InstituteCourse.Course.CourseName}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* DisputeSubject */}
                    <div className="flex flex-col gap-[10px]">
                        <label className="text-[#404040] text-[18px]">
                            1. What is this dispute about?*
                        </label>
                        <select
                            id="disputeSubject"
                            name="disputeSubject"
                            className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029]`}
                            value={formData.disputeSubject}
                            onChange={handleChange}
                        >
                            <option value="">Select an option</option>
                            <option value="Charged different amount then expected">
                                1. Charged different amount then expected.
                            </option>
                            <option value="Instruction method is not satisfactory">
                                2. Instruction method is not satisfactory.
                            </option>
                            <option value="Class schedule conflicting with priorities">
                                3. Class schedule conflicting with priorities.
                            </option>
                            <option value="Unable to continue training due to personal reasons.">
                                4. Unable to continue training due to personal reasons.
                            </option>
                            <option value="Registered in a wrong course">
                                5. Registered in a wrong course.
                            </option>
                            <option value="Distance from Training Institute is unmanageable">
                                6. Distance from Training Institute is unmanageable.
                            </option>
                        </select>
                    </div>

                    {/* Last Class Received */}
                    {lastClassDate && (
                    <div className="flex flex-col gap-[10px]">
                        <label className="text-[#404040] text-[18px]">
                            2. Did you received your last class on {lastClassDate}?*
                        </label>
                        <div className="flex gap-[10px]">
                            <input
                                type="radio"
                                id="yes"
                                name="lastClassReceived"
                                value="yes"
                                checked={formData.lastClassReceived === "yes"}
                                onChange={handleChange}
                                className="mr-2"
                            />
                            <label htmlFor="yes" className="text-[18px] text-[#404040]">
                                Yes
                            </label>
                        </div>
                        <div className="flex gap-[10px]">
                            <input
                                type="radio"
                                id="no"
                                name="lastClassReceived"
                                value="no"
                                checked={formData.lastClassReceived === "no"}
                                onChange={handleChange}
                                className="mr-2"
                            />
                            <label htmlFor="no" className="text-[18px] text-[#404040]">
                                No
                            </label>
                        </div>
                    </div>
                    )}

                    {/* Dispute Reason */}
                    <div className="flex flex-col gap-[10px]">
                        <label className="text-[#404040] text-[18px]">
                            {lastClassDate ? "3" : "2"}. Please provide your reason why you applied for the dispute?*
                        </label>
                        <textarea
                            id="disputeReason"
                            name="disputeReason"
                            placeholder="Enter your reason here..."
                            className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029]`}
                            style={{ height: "150px", resize: "none" }}
                            value={formData.disputeReason}
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    {/* Attachments */}
                    <div className="flex flex-col gap-[10px]">
                        <label className="text-[#404040] text-[18px]">
                         {lastClassDate ? "4" : "3"}. Attach any document, image, or proof.
                        </label>
                        <div className="flex gap-[5px]">
                            {previewImage ? (
                                <img src={previewImage} alt="Preview" className="h-[80px] w-[90px] object-cover" />
                            ) : null}
                            <input
                                type="file"
                                accept="image/*"
                                className="hidden"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                            />
                            <img
                                src={OpenDisputeAttach}
                                alt="Attach Icon"
                                className="cursor-pointer mt-[-10px]"
                                onClick={handleAttachIconClick}
                            />
                            <p className="text-[#000000] text-[12px]">Jpeg, PNG, PDF, or GIF</p>
                        </div>
                    </div>
                    {errors && (
                        <p className="text-[16px] text-[#ff0000]">{errors}</p>
                    )}
                    <div className="w-full flex justify-end lg:mt-[-10px]">
                        <button className="w-[110px] h-[44px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px]" onClick={handleSubmit}>
                            Submit
                        </button>
                    </div>
                </div>

                {showPopup && <SettingsPopup setShowPopup={setShowPopup} text="The Dispute has been created. We will try to resolve it as soon as possible. The page will refresh in 5 seconds to reflect the new dispute." />}
            </div>
            ) : (
                <NoDataResponse topText="You are not enrolled in any courses." />
            )}
        </>
    );
};

export default SettingsOpenDispute;
